// extracted by mini-css-extract-plugin
export default {"box-item-list":"BoxItemList_box-item-list__8PxF0"};